import { render, staticRenderFns } from "./CompetitorActivitySection.vue?vue&type=template&id=41a4107d&scoped=true"
import script from "./CompetitorActivitySection.vue?vue&type=script&lang=js"
export * from "./CompetitorActivitySection.vue?vue&type=script&lang=js"
import style0 from "./CompetitorActivitySection.vue?vue&type=style&index=0&id=41a4107d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a4107d",
  null
  
)

export default component.exports